import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import {createGtag} from "vue-gtag"

const app = createApp(App)
// Google Analytics 연동 설정 추가
app.use(
    createGtag({
        tagId: "G-VT8R1JV1P5", // 필수 값
        appName: "upick-landing",
        pageTracker: {
            router: router
        }
    })
)

app.use(router)
app.mount('#app')